import { BrowserRouter } from 'react-router-dom';

import { SessionProvider } from '../auth/session';
import { ToastProvider } from '../components/Toast';
import { ThemeProvider } from '../theme/ThemeProvider';

import { AppRoutes } from './routes';

/**
 * Root of the Docsight single-page app: theme, session (auth + token + guards
 * plumbing), a toast host, the router and the routes. The session resolves any
 * stored token on mount, so a returning user lands authenticated; a fresh user
 * is redirected to /login by the route guards.
 */
export function App(): React.JSX.Element {
  return (
    <ThemeProvider>
      <SessionProvider>
        <ToastProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </ToastProvider>
      </SessionProvider>
    </ThemeProvider>
  );
}
